import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import url from "../../services/url";
import { If, Else } from "react-condition";
import GetFormComponent from "../Candidate/GetFormComponent";
import PersonalDetails from "../Candidate/ApplicationView.PersonalDetails";
import slugify from "slugify";
import swal from "sweetalert";
import ReactLoading from "react-loading";
import { prefilledDocData } from "./utils/prefilledDocData";
import { professionalExpKeys } from "./utils/professionalExpSchema";

const OCR_KEYS = {
  "Upload Cancelled Cheque": "cancelCheque",
  "Upload Blood group": "bloodGroup",
  "Upload Caste Certificate": "casteCertificate",
  "Upload 10th Certificate": "tenthCertificate",
  "Upload 12th Certificate": "twelfthCertificate",
  "Upload Graduation Certificate": "graduationCertificate",
  "Upload Postgraduate Certificate": "postGraduationCertificate",
  "Appointment letter/Offer letter": "offerLetter",
  "Experience Letter/Relieving Letter": "experienceLetter",
  "Salary slips or bank statement of last three months": "salarySlip",
};

const AGENT_APPLICATION_ID = "61d41ac7cc03506243d626f9";

function CandidateDocView({
  isHRPanel,
  onBlurHandler,
  isInputFieldTouched,
  candidateId,
  formData,
  setToggleAlert,
  toggleAlert,
  reason,
  approve,
  status,
  rights,
  filled,
  aadharDetails,
  setIsFieldTouch,
  setActiveDocKey,
  getCandidateFormsList,
  aiSettings,
  departments,
}) {
  // Uncommon Hooks
  const { id } = useParams();
  const formUniqueId = formData._id;
  const FORM_NAME = formData?.formId?.name;
  const FORM_ID = formData?.formId?._id;
  localStorage.setItem("form_id", formData._id);
  const _aadhar = aadharDetails || {};
  const {
    house,
    street,
    state: _state,
    loc,
    dist,
    landmark,
    vtc,
  } = _aadhar?.aadharVerificationDetails?.data?.address || {};

  const ADDRESS =
    _aadhar?.aadharVerificationDetails?.data?.full_address ||
    [house, street, landmark, vtc, loc, dist, _state]
      .filter(Boolean)
      .join(", ") ||
    "";
  const ZIP = _aadhar?.aadharVerificationDetails?.data?.zip || "";

  const [load, setLoad] = useState(false);
  // States
  const [form, setForm] = useState({});
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // add validation just below the input box
  const [formError, setFormError] = useState({});
  const [candidateInformation, setCandidateInformation] = useState(null);

  const [ocrDisabled, setOcrDisabled] = useState(false);
  const [ocrData, setOcrData] = useState(null);
  const [errorInputs, setErrorInputs] = useState([]);
  const [errorOcrInputs, setErrorOcrInputs] = useState([]);

  useEffect(() => {
    if (!candidateInformation) return;

    let disable = false;
    let ocr_data = {};
    let count = 0;
    let childIds = [];

    const formData = candidateInformation;

    formData?.formId?.elements?.forEach((ele, index) => {
      if (ele.type === "select" || ele.type === "radio") {
        if (ele?.parent && ele?.parent?.length !== 0) {
          for (let s of ele?.parent) {
            childIds.push(s.child.id);
          }
        }
      }
    });

    formData?.formId?.elements?.forEach((ele, index) => {
      if (!childIds.includes(ele.id)) {
        if (ele.type === "select" || ele.type === "radio") {
          if (ele?.parent && ele?.parent?.length !== 0) {
            let founded = null;
            for (let s of ele?.parent) {
              if (formData?.responses?.length !== 0) {
                founded = formData?.responses?.some(
                  (t) => t.element.id === s.child.id,
                );
              }
            }
            if (founded) {
              count++;
            }
          }
          count++;
        } else {
          count++;
        }
      }
    });

    const mandateFileCount = formData?.formId?.elements
      ?.map((file) => {
        if (
          file.type === "file" &&
          file?.properties?.required &&
          !childIds.includes(file.id)
        ) {
          return file;
        }
      })
      .filter(Boolean);

    if (formData?.formId?.name === "Bank Details") {
      let isMandateFieldUploaded = 0;
      for (let data of formData?.formId?.elements) {
        if (data?.type === "file") {
          let found = null;
          for (let file of formData?.files) {
            if (file?.fieldname === data?.properties?.label) {
              found = file;
            }
          }
          if (found) {
            ocr_data[OCR_KEYS[data?.properties?.label]] = {
              ...(found?.OCRData?.response || {}),
              isActive: found?.OCRData?.isActive,
            };
          }
          if (data?.properties?.required && !childIds.includes(data.id)) {
            if (found) {
              isMandateFieldUploaded++;
            }
          }
        }
      }
      if (mandateFileCount.length !== isMandateFieldUploaded) {
        disable = true;
      }
    }

    if (formData?.formId?.name === "Candidate Information Form") {
      let isMandateFieldUploaded = 0;
      for (let data of formData?.formId?.elements) {
        if (data?.type === "file") {
          let found = null;
          for (let file of formData?.files) {
            if (file?.fieldname === data?.properties?.label) {
              found = file;
            }
          }
          if (found) {
            ocr_data[OCR_KEYS[data?.properties?.label]] = {
              ...(found?.OCRData?.response || {}),
              isActive: found?.OCRData?.isActive,
            };
          }
          if (data?.properties?.required && !childIds.includes(data.id)) {
            if (found) {
              isMandateFieldUploaded++;
            }
          }
        }
      }
      if (mandateFileCount.length !== isMandateFieldUploaded) {
        disable = true;
      }
    }

    if (formData?.formId?.name === "Professional Experience") {
      let isMandateFieldUploaded = 0;
      for (let data of formData?.formId?.elements) {
        if (data?.type === "file") {
          let found = null;
          for (let file of formData?.files) {
            if (file?.fieldname === data?.properties?.label) {
              found = file;
            }
          }
          if (found) {
            ocr_data[OCR_KEYS[data?.properties?.label]] = {
              ...(found?.OCRData?.response || {}),
              isActive: found?.OCRData?.isActive,
            };
          }
          if (data?.properties?.required && !childIds.includes(data.id)) {
            if (found) {
              isMandateFieldUploaded++;
            }
          }
        }
      }
      if (mandateFileCount.length !== isMandateFieldUploaded) {
        disable = true;
      }
    }

    if (Object.keys(ocr_data).length !== 0) {
      setOcrData({
        ...ocrData,
        ...ocr_data,
      });
    } else {
      setOcrData(null);
    }
    setOcrDisabled(disable);
  }, [candidateInformation]);

  const fillOcrData = (data) => {
    setErrorOcrInputs((prev) => {
      const index = prev.findIndex((item) => item.key === data.key);
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = data;
        return updated;
      } else {
        return [...prev, data];
      }
    });
  };

  const canSubmit = () => {
    return errorOcrInputs.every((obj) =>
      Object.values(obj).every((value) => value === ""),
    );
  };

  useEffect(() => {
    if (!formData) return;
    setCandidateInformation(formData);
    const results = filterChildElements(formData?.formId?.elements);
    setForm({
      ...formData?.formId,
      elements: [...PersonalDetails.elements, ...results],
    });
  }, [id, formData]);

  // Effects
  useEffect(() => {
    if (!formData) return;
    const init = async () => {};

    init();
  }, [id, formData]);

  //Remove child from main array -Lovejot(06-DEC-2022)
  const filterChildElements = (elementsArray) => {
    let arrr = [];
    for (let item of elementsArray) {
      if (item === null) {
        continue;
      } else {
        if (item?.type === "select") {
          for (let i = 0; i < item?.parent?.length; i++) {
            arrr.push(item?.parent[i]?.child?.id);
          }
        }
      }
    }

    const results = elementsArray.filter(
      (ele) => ele != null && !arrr.some((index) => index === ele.id),
    );

    return results;
  };

  async function onClickFormSubmit(event) {
    event.preventDefault();
    setToggleAlert(true);

    setError("");

    let formData = [];

    let error = [];
    setErrorInputs(error);

    let currentError = "";

    document
      .querySelectorAll(".ant-collapse-item-active .form-view")
      .forEach((input) => {
        let d = JSON.parse(input.getAttribute("data"));
        let element = {};
        element = d;
        let data = {};
        let supplement = true;
        if (element && Object.keys(element).length !== 0) {
          // Input Generation
          if (element.type === "texttable") {
            let testData = formData.filter((d) => {
              return d.label === input.getAttribute("label");
            });
            if (testData.length >= 1) {
              supplement = false;
            } else {
              let value = {};
              document
                .querySelectorAll(
                  "[name='" + slugify(element.properties.label) + "']",
                )
                .forEach((textfield) => {
                  let row = textfield.getAttribute("row");
                  let column = textfield.getAttribute("column");
                  if (value[row] === null || value[row] === undefined) {
                    value[row] = {};
                    value[row][column] = textfield.value;
                  } else {
                    value[row][column] = textfield.value;
                  }
                });
              data = {
                label: input.getAttribute("label"),
                value: JSON.stringify(value),
                element,
              };
            }
          } else if (element.type === "checkbox") {
            let testData = formData.filter((d) => {
              return d.label === input.getAttribute("label");
            });
            if (testData.length >= 1) {
              supplement = false;
            } else {
              let value = [];
              document
                .querySelectorAll(
                  "[name='" + slugify(element.properties.label) + "']:checked",
                )
                .forEach((checkbox) => {
                  if (checkbox.checked) {
                    value.push(checkbox.getAttribute("value"));
                  }
                });
              data = {
                label: input.getAttribute("label"),
                value,
                element,
              };
            }
          } else if (element.type === "radio") {
            let testData = formData.filter((d) => {
              return d.label === input.getAttribute("label");
            });
            if (testData.length >= 1) {
              supplement = false;
            } else {
              let radio = document.querySelector(
                "[name='" + slugify(element.properties.label) + "']:checked",
              );
              let value = null;
              if (radio !== null) {
                value = radio.value;
              }
              data = {
                label: input.getAttribute("label"),
                value,
                element,
              };
            }
          } else if (element.type === "multiSelect") {
            data = {
              label: input.getAttribute("label"),
              value: element.properties.value,
              element,
            };
          } else if (element.type === "datetime") {
            data = {
              label: input.getAttribute("label"),
              value: element.properties.value,
              element,
            };
          } else if (element.type === "professionalexperience") {
            data = {
              label: "professionalexperience",
              value: element.value,
              element,
            };
          } else if (element.type === "statecity") {
            data = {
              label: "statecity",
              valueOfField: [
                {
                  label: "Select State",
                  value: element?.value?.state || "",
                  element,
                },
                {
                  label: "Select City",
                  value: element?.value?.city || "",
                  element,
                },
              ],
              element,
            };
          } else if (element.type === "departmentdesignation") {
            const { value, ...rest } = element;
            data = {
              label: "departmentdesignation",
              valueOfField: [
                {
                  label: "Select Department",
                  value: element?.value?.departmentText || "",
                  element: rest,
                  _id: element?.value?.department || "",
                },
                {
                  label: "Select Designation",
                  value: element?.value?.designationText || "",
                  element: rest,
                  _id: element?.value?.designation || "",
                },
              ],
              element: rest,
            };
          } else if (
            element.type === "file" &&
            document.getElementById(element.id).files[0] === undefined
          ) {
            data = {
              label: input.getAttribute("label"),
              value: element.properties.value,
              element,
            };
          } else if (
            element.type === "file" &&
            document.getElementById(element.id).files[0] === undefined
          ) {
            data = {
              label: input.getAttribute("label"),
              value: element.properties.value,
              element,
            };
          } else {
            if (input instanceof HTMLDivElement) {
              data = {
                label: input.getAttribute("label"),
                value: input.getAttribute("value"),
                element,
              };
            } else {
              data = {
                label: input.getAttribute("label"),
                value: input.value,
                element,
              };
            }
          }

          // Input Validation
          if (supplement) {
            if (
              data.element.type === "professionalexperience" &&
              data.element.properties.required
            ) {
              let errors = {};
              const userData = data.value || {};
              for (let empKey in professionalExpKeys) {
                if (
                  professionalExpKeys[empKey]?.filled <=
                  data.element?.filledOnly
                ) {
                  errors[empKey] = {};
                  const template = professionalExpKeys[empKey];
                  const filled = userData[empKey] || {};

                  const merged = { ...template, ...filled };

                  for (let field in template) {
                    const val = merged[field];

                    if (!val || String(val).trim() === "") {
                      errors[empKey][field] = "This field is required";
                    }

                    if (
                      field.includes("mobile_no") &&
                      val &&
                      val.length !== 10
                    ) {
                      errors[empKey][field] = "Mobile number must be 10 digits";
                    }
                  }

                  const fromDate = merged[`${empKey}_from_date`];
                  const toDate = merged[`${empKey}_to_date`];
                  if (
                    fromDate &&
                    toDate &&
                    new Date(fromDate) >= new Date(toDate)
                  ) {
                    errors[empKey][`${empKey}_from_date`] =
                      "From Date must be smaller than To Date";
                  }
                }
              }

              if (
                errors.last_emp ||
                errors.last_to_last_emp ||
                errors.last_to_second_last_emp
              ) {
                if (
                  (errors.last_emp &&
                    Object.keys(errors.last_emp).length > 0) ||
                  (errors.last_to_last_emp &&
                    Object.keys(errors.last_to_last_emp).length > 0) ||
                  (errors.last_to_second_last_emp &&
                    Object.keys(errors.last_to_second_last_emp).length > 0)
                )
                  error.push({
                    label: data.element.type,
                    value: errors,
                  });
              }
            }

            if (element.type === "statecity") {
              let checkCity = false;
              for (let i = 0; i < data?.valueOfField?.length; i++) {
                if (
                  data?.valueOfField[i]?.element.properties.required === true
                ) {
                  if (data?.valueOfField[i].value === "") {
                    currentError = `State and City is required field.`;
                    error.push({
                      label: data?.valueOfField[i].label,
                      value: `State and City is required field.`,
                    });
                  }
                } else {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select state"
                  ) {
                    if (data?.valueOfField[i].value !== "") {
                      checkCity = true;
                    }
                  }
                  if (checkCity) {
                    if (
                      data?.valueOfField[i].label.toLowerCase().trim() ===
                      "select city"
                    ) {
                      if (data?.valueOfField[i].value === "") {
                        currentError = `City is required field.`;
                        error.push({
                          label: data?.valueOfField[i].label,
                          value: `City is required field.`,
                        });
                      }
                    }
                  }
                }
              }
            }

            if (element.type === "departmentdesignation") {
              let checkDesignation = false;
              for (let i = 0; i < data?.valueOfField?.length; i++) {
                if (
                  data?.valueOfField[i]?.element.properties.required === true
                ) {
                  if (data?.valueOfField[i].value === "") {
                    currentError = `Department and Designation is required field.`;
                    error.push({
                      label: data?.valueOfField[i].label,
                      value: `Department and Designation is required field.`,
                    });
                  }
                } else {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select department"
                  ) {
                    if (data?.valueOfField[i].value !== "") {
                      checkDesignation = true;
                    }
                  }
                  if (checkDesignation) {
                    if (
                      data?.valueOfField[i].label.toLowerCase().trim() ===
                      "select designation"
                    ) {
                      if (data?.valueOfField[i].value === "") {
                        currentError = `Designation is required field.`;
                        error.push({
                          label: data?.valueOfField[i].label,
                          value: `Designation is required field.`,
                        });
                      }
                    }
                  }
                }
              }
            }

            if (element.properties !== null) {
              if (typeof data.value === "string") {
                let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
                if (data.element.isAlpha === true && data.value.length !== 0) {
                  if (!data.value.trim().match(alphabets)) {
                    currentError = `Only alphabets are allowed in ${data.label}`;
                    error.push({
                      label: data.label,
                      value: `Only alphabets are allowed in ${data.label}`,
                    });
                  }
                }
                let isnum = /^\d+$/;
                if (data.element.isNumber === true && data.value.length !== 0) {
                  if (!isnum.test(data.value)) {
                    currentError = `Only Numbers are allowed in ${data.label}`;
                    error.push({
                      label: data.label,
                      value: `Only Numbers are allowed in ${data.label}`,
                    });
                  }
                }
                if (
                  data.element.type === "text" ||
                  data.element.type === "textarea" ||
                  data.element.type === "number"
                ) {
                  if (data.value.length !== 0) {
                    if (
                      data.element.properties.minLengthValidation !==
                        undefined &&
                      data.element.properties.maxLengthValidation !== undefined
                    ) {
                      if (
                        data.value.trim().length >=
                          parseInt(
                            data.element.properties.minLengthValidation,
                          ) &&
                        data.value.trim().length <=
                          parseInt(data.element.properties.maxLengthValidation)
                      ) {
                        console.log("val error");
                      } else {
                        currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                        error.push({
                          label: data.label,
                          value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`,
                        });
                      }
                    }
                  }
                }
                var emailPattern = new RegExp(
                  /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                );
                // email validation
                if (data.label.trim() === "Email" && data.value.trim() === "") {
                  currentError =
                    "'" +
                    element.properties.label +
                    "' is a required question.";
                  error.push({
                    label: element.properties.label,
                    value:
                      element.properties.label + " is a required question.",
                  });
                } else if (
                  data.label === "Email" &&
                  !emailPattern.test(data.value)
                ) {
                  currentError =
                    "Invalid email id format, Please fill correct email id";
                  error.push({
                    label: element.properties.label,
                    value:
                      "Invalid email id format, Please fill correct email id",
                  });
                }

                if (data.label === "Date of Birth") {
                  var date = data.value.split("-");

                  // Date of Age should be between 18-40 years

                  var daterange = data.value;

                  var today = new Date();
                  var birthDate = new Date(daterange);
                  var age = today.getFullYear() - birthDate.getFullYear();
                  var m = today.getMonth() - birthDate.getMonth();
                  if (
                    m < 0 ||
                    (m === 0 && today.getDate() < birthDate.getDate())
                  ) {
                    age--;
                  }
                  if (age <= 17) {
                    currentError = "Age should not smaller than 18 year";
                    error.push({
                      label: element.properties.label,
                      value: "Age should not smaller than 18 year",
                    });
                  } else if (age > 55) {
                    currentError = "Age should not greater than 55 year";
                    error.push({
                      label: element.properties.label,
                      value: "Age should not greater than 55 year",
                    });
                  }
                }
                if (
                  data.label === "Date of Birth" &&
                  data.value.trim() === ""
                ) {
                  currentError =
                    "'" + element.properties.label + "' is a required field.";
                  error.push({
                    label: element.properties.label,
                    value: element.properties.label + " is a required field.",
                  });
                } else if (data.label === "Date of Birth") {
                  if (date[0] < 1000 || date[0].length > 4) {
                    currentError = "Please enter valid date of birth";
                    error.push({
                      label: element.properties.label,
                      value: "Please enter valid date of birth",
                    });
                  }
                }
              }
            }

            if (element.properties !== null) {
              if (element.properties.required !== null) {
                if (element.properties.required === true) {
                  // Validate Stringed Inputs
                  if (typeof data.value === "string") {
                    if (data.label === "Date of Birth") {
                      var date = data.value.split("-");

                      // Date of Age should be between 18-40 years

                      var daterange = data.value;

                      var today = new Date();
                      var birthDate = new Date(daterange);
                      var age = today.getFullYear() - birthDate.getFullYear();
                      var m = today.getMonth() - birthDate.getMonth();
                      if (
                        m < 0 ||
                        (m === 0 && today.getDate() < birthDate.getDate())
                      ) {
                        age--;
                      }
                      if (age <= 17) {
                        currentError = "Age should not smaller than 18 year";
                        error.push({
                          label: element.properties.label,
                          value: "Age should not smaller than 18 year",
                        });
                      } else if (age > 55) {
                        currentError = "Age should not greater than 55 year";
                        error.push({
                          label: element.properties.label,
                          value: "Age should not greater than 55 year",
                        });
                      }
                    }
                    var languagePattern = new RegExp(/[^A-Z -,]/gi);
                    var pattern = new RegExp(/^[0-9\b]+$/);
                    var emailPattern = new RegExp(
                      /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                    );

                    if (data.value.trim() === "") {
                      if (data.label === "Name" && data.value.trim() === "") {
                        error.push({
                          label: element.properties.label,
                          value:
                            element.properties.label +
                            " is a required question.",
                        });
                      }
                    }

                    if (
                      data.label === "Phone Number" &&
                      data.value.length !== 10
                    ) {
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid mobile format. Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      !pattern.test(data.value)
                    ) {
                      error.push({
                        label: element.properties.label,
                        value: "Please enter only 10-digit mobile number.",
                      });
                    }

                    //Dynamic validations for alphabets -Lovejot(12-DEC-2022)
                    let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
                    if (
                      data.element.isAlpha === true &&
                      data.value.length !== 0
                    ) {
                      if (!data.value.trim().match(alphabets)) {
                        currentError = `Only alphabets are allowed in ${data.label}`;
                        error.push({
                          label: element.properties.label,
                          value:
                            "Only alphabets are allowed in " +
                            element.properties.label,
                        });
                      }
                    }

                    //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
                    let isnum = /^\d+$/;
                    if (
                      data.element.isNumber === true &&
                      data.value.length !== 0
                    ) {
                      if (!isnum.test(data.value)) {
                        currentError = `Only Numbers are allowed in ${data.label}`;
                        error.push({
                          label: element.properties.label,
                          value:
                            "Only Numbers are allowed in " +
                            element.properties.label,
                        });
                      }
                    }

                    if (
                      data.element.type === "text" ||
                      data.element.type === "textarea" ||
                      data.element.type === "number"
                    ) {
                      if (
                        data.element.properties.minLengthValidation !==
                          undefined &&
                        data.element.properties.maxLengthValidation !==
                          undefined
                      ) {
                        if (
                          data.value.trim().length >=
                            parseInt(
                              data.element.properties.minLengthValidation,
                            ) &&
                          data.value.trim().length <=
                            parseInt(
                              data.element.properties.maxLengthValidation,
                            )
                        ) {
                          console.log("val error");
                        } else {
                          currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                          error.push({
                            label: data.label,
                            value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.minLengthValidation} are allowed in ${data.label}`,
                          });
                        }
                      }
                    }

                    //Aadhar Number Validation
                    if (
                      data.label === "Aadhar Number" &&
                      data.value.length !== 12
                    ) {
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid Aadhar format. Please enter only 12-digit aadhar number.",
                      });
                    } else if (
                      data.label === "Aadhar Number" &&
                      !pattern.test(data.value)
                    ) {
                      error.push({
                        label: element.properties.label,
                        value: "Please enter only 12-digit aadhar number.",
                      });
                    }

                    // Validate Address
                    if (data.label === "Address" && data.value.trim() === "") {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required field.",
                      });
                    } else if (
                      data.label === "Address" &&
                      data.value.length >= 400
                    ) {
                      error.push({
                        label: element.properties.label,
                        value: "Address should not more than 400 character",
                      });
                    }
                    // email validation
                    if (data.label === "Email" && data.value.trim() === "") {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required field.",
                      });
                    } else if (
                      data.label === "Email" &&
                      !emailPattern.test(data.value)
                    ) {
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid email id format, Please fill correct email id",
                      });
                    }

                    // Validate Date of birth
                    if (
                      data.label === "Date of Birth" &&
                      data.value.trim() === ""
                    ) {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required field.",
                      });
                    } else if (data.label === "Date of Birth") {
                      if (date[0] < 1000 || date[0].length > 4) {
                        error.push({
                          label: element.properties.label,
                          value: "Please enter valid date of birth",
                        });
                      }
                    }

                    // Validation on languages
                    if (
                      data.label === "Indian Languages" &&
                      data.value.trim() === ""
                    ) {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required field.",
                      });
                    } else if (
                      data.label === "Indian Languages" &&
                      languagePattern.test(data.value)
                    ) {
                      error.push({
                        label: element.properties.label,
                        value:
                          "Please enter correct languages, seperate by comma.",
                      });
                    }

                    // proper validation on the bottom of page

                    if (
                      data.element.type !== "file" &&
                      data.element.type !== "professionalexperience" &&
                      data.element.type !== "statecity" &&
                      data.element.type !== "departmentdesignation"
                    ) {
                      if (
                        data.value.trim() === "" ||
                        data.value.trim() === "null"
                      ) {
                        currentError =
                          "Please fill out this field to proceed further";
                        error.push({
                          label: element.properties.label,
                          value:
                            "Please fill out this field to proceed further",
                        });
                      } else if (
                        data.label === "Phone Number" &&
                        data.value.length !== 10
                      ) {
                        currentError =
                          "Invalid mobile format. Please enter only 10-digit mobile number.";
                        error.push({
                          label: element.properties.label,
                          value:
                            "Invalid mobile format. Please enter only 10-digit mobile number.",
                        });
                      } else if (
                        data.label === "Phone Number" &&
                        !pattern.test(data.value)
                      ) {
                        currentError =
                          "Please enter only 10-digit mobile number.";
                        error.push({
                          label: element.properties.label,
                          value: "Please enter only 10-digit mobile number.",
                        });
                      } else if (
                        data.label === "Name" &&
                        data.value.length >= 40
                      ) {
                        currentError = "Name should not more than 40 character";
                        error.push({
                          label: element.properties.label,
                          value: "Name should not more than 40 character",
                        });
                      } else if (
                        data.label === "Address" &&
                        data.value.length >= 400
                      ) {
                        currentError =
                          "Address should not more than 400 character";
                        error.push({
                          label: element.properties.label,
                          value: "Address should not more than 400 character",
                        });
                      } else if (
                        data.label === "Email" &&
                        !emailPattern.test(data.value)
                      ) {
                        currentError = "Invalid email id format";
                        error.push({
                          label: element.properties.label,
                          value:
                            "Invalid email id format, Please fill correct email id",
                        });
                      } else if (data.label === "Date of Birth") {
                        if (date[0] < 1000 || date[0].length > 4) {
                          currentError = "Please enter valid date of birth";
                          error.push({
                            label: element.properties.label,
                            value: "Please enter valid date of birth",
                          });
                        }
                      }
                    }
                  }
                  //   Validate Non-Stringed Inputs
                  if (
                    (!data.value || data.value?.length === 0) &&
                    data.element.type !== "file" &&
                    data.element.type !== "professionalexperience" &&
                    data.element.type !== "statecity" &&
                    data.element.type !== "departmentdesignation"
                  ) {
                    if (data.value === null || data.value.length === 0) {
                      currentError =
                        "Please fill out this field to proceed further";
                      error.push({
                        label: element.properties.label,
                        value: "Please fill out this field to proceed further",
                      });
                    }
                  } else if (element.properties.required === false) {
                    if (typeof data.value === "string") {
                      //Regular expression for validation
                      if (data.label === "Date of Birth") {
                        var date = data.value.split("-");

                        // Date of Age should be between 18-40 years

                        var daterange = data.value;

                        var today = new Date();
                        var birthDate = new Date(daterange);
                        var age = today.getFullYear() - birthDate.getFullYear();
                        var m = today.getMonth() - birthDate.getMonth();
                        if (
                          m < 0 ||
                          (m === 0 && today.getDate() < birthDate.getDate())
                        ) {
                          age--;
                        }
                        if (age <= 17) {
                          currentError = "Age should not smaller than 18 year";
                          error.push({
                            label: element.properties.label,
                            value: "Age should not smaller than 18 year",
                          });
                        } else if (age > 55) {
                          currentError = "Age should not greater than 55 year";
                          error.push({
                            label: element.properties.label,
                            value: "Age should not greater than 55 year",
                          });
                        }
                      }
                    }
                  }
                }
              }
              // Validate with Browser Validity
              try {
                if (input.checkValidity() === false) {
                  currentError =
                    "'" +
                    element.properties.label +
                    "' contains an invalid answer. " +
                    input.validationMessage;
                  error.push({
                    label: element.properties.label,
                    value: input.validationMessage,
                  });
                }
              } catch (e) {}
            }
          }
        }
        if (supplement && data !== null && JSON.stringify(data) !== "{}") {
          if (data?.valueOfField && Array.isArray(data.valueOfField)) {
            formData = [...formData, ...data.valueOfField];
          } else {
            formData.push(data);
          }
        }
      });

    let payload = new FormData();

    if (formData.length !== 0) {
      formData.map((ele) => {
        if (ele?.element?.type === "file") {
          let file = document.getElementById(ele.element.id).files[0];
          if (file) {
            let extension = file.name.split(".").pop().toLowerCase();
            let ext = [];
            for (let key in ele.element.extensions) {
              if (ele.element.extensions[key]) {
                ext.push(key);
              }
            }
            let size =
              file.size <= parseInt(ele.element.properties.size) * 1024;
            if (!size) {
              error.push({
                label: ele.element.properties.label,
                value: `Your ${ele.element.properties.label} must not be larger than ${ele.element.properties.size} kb`,
              });
            } else {
              if (ext.includes(extension)) {
                payload.append(ele.element.properties.label, file);
              } else {
                error.push({
                  label: ele.element.properties.label,
                  value: `The image is in an unsupported extension '${extension}'.`,
                });
              }
            }
          } else {
            if (
              ele.element.properties.required &&
              (ele.value === "" || ele.value === undefined)
            ) {
              const fieldName_ = ele.element.properties.label;

              if (fieldName_.toLowerCase().indexOf("upload 10th") === 0) {
                error.push({
                  label: ele.element.properties.label,
                  value: `Uploading your 10th-grade certificate is mandatory.`,
                });
              } else if (
                fieldName_.toLowerCase().indexOf("upload 12th") === 0
              ) {
                error.push({
                  label: ele.element.properties.label,
                  value: `Uploading your 12th-grade certificate is mandatory`,
                });
              } else if (
                fieldName_.toLowerCase().indexOf("upload caste") === 0
              ) {
                error.push({
                  label: ele.element.properties.label,
                  value: `Please upload your category certificate to proceed.`,
                });
              } else if (
                fieldName_.toLowerCase().indexOf("upload blood") === 0
              ) {
                error.push({
                  label: ele.element.properties.label,
                  value: `Uploading your blood group certificate is mandatory`,
                });
              } else {
                error.push({
                  label: ele.element.properties.label,
                  value: `You must attach your ${ele.element.properties.label}`,
                });
              }
            } else {
              let highestQualification =
                formData.find((ele) => ele.label === "Highest qualification")
                  ?.value || null;

              let castCategory =
                formData.find(
                  (ele) =>
                    ele.label ===
                    "Please confirm if you have relevant category certificate.",
                )?.value || null;

              const fieldName = ele.element.properties.label;
              if (
                (highestQualification || "").toLocaleLowerCase() ===
                  "post graduate" &&
                fieldName.toLowerCase().indexOf("upload postgraduate") === 0 &&
                !ele.value
              ) {
                let graduate =
                  formData.find(
                    (ele) => ele.label === "Upload Graduation Certificate",
                  )?.value || null;

                error.push({
                  label: ele.element.properties.label,
                  value: `Post Graduation is mandatory if highest qualification is Post Graduation.`,
                });

                if (!graduate) {
                  error.push({
                    label: "Upload Graduation Certificate",
                    value: `Graduation is mandatory if highest qualification is Post Graduation.`,
                  });
                }
              }
              if (
                (highestQualification || "").toLocaleLowerCase() ===
                  "graduate" &&
                fieldName.toLowerCase().indexOf("upload graduation") === 0 &&
                !ele.value
              ) {
                error.push({
                  label: ele.element.properties.label,
                  value: `Graduation is mandatory if highest qualification is Graduation.`,
                });
              }
              if (
                (castCategory || "").toLocaleLowerCase() === "yes" &&
                fieldName.toLowerCase().indexOf("upload caste") === 0 &&
                !ele.value
              ) {
                error.push({
                  label: ele.element.properties.label,
                  value: `Please upload your category certificate to proceed.`,
                });
              }
            }
          }
        }
      });
    }

    // Handle Form Submission
    if (currentError === "" && error.length === 0 && canSubmit()) {
      if (FORM_NAME === "Bank Details") {
        const flag = await swal({
          title: "Disclaimer",
          // text: "Are you sure you want to submit this Form?",
          icon: null,
          content: {
            element: "div",
            attributes: {
              innerHTML: `
            <div style="padding:0 20px">
          <p style="text-align:left">
            By uploading your <strong>cancelled cheque</strong> or 
            <strong>bank passbook</strong>, you confirm that the bank account belongs to you and you 
            <strong>agree to receive your salary payments into this account.</strong>
          </p>
  
          <p style="text-align:left">Please ensure the uploaded document clearly shows the following:</p>
          <ul style="padding-left: 20px; margin-top: 0;">
            <li style="text-align:left">Your name</li>
            <li style="text-align:left">Account number</li>
            <li style="text-align:left">IFSC code</li>
            <li style="text-align:left">Bank name</li>
          </ul>
  
          <p style="margin-top: 10px;">
            <span style="color: #d99e00;">⚠️</span> 
            The document must not be blurred, cropped, or edited.
          </p>
        </div>      
              `,
            },
          },
          className: "custom-swal-container",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "",
              closeModal: true,
            },
            confirm: {
              text: "I Acknowledge",
              value: true,
              visible: true,
              className: "",
              closeModal: true,
            },
          },
        });
        if (!flag) return;
      }

      setLoad(true);

      payload.append("response", JSON.stringify(formData));
      payload.append("form", id);

      const link = `candidateDocuments/${formUniqueId}`;

      Axios.put(url(link), payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("candidate.token")}`,
        },
      })
        .then(async (result) => {
          setSuccess(true);
          localStorage.setItem("ids", result.data.id);
          // swal({
          //   title: "Form Submitted , Successfully!",
          //   icon: "success",
          //   dangerMode: true,
          //   button: {
          //     text: "OK",
          //     closeModal: false
          //   }
          // }).then((willDelete) => {
          //   if (willDelete) {
          //     window.location.reload();
          //   } else {
          //     window.location.reload();
          //   }
          // });
          await getCandidateFormsList();
          setIsFieldTouch(false);
          setActiveDocKey(null);
          setToggleAlert(false);
          setLoad(false);
        })
        .catch((error) => {
          if (error.response.data.error.name === "MongoError") {
            setError("Email is already in use. Please use another email.");
          } else if (error.response.data.error === "Mobile No already Exist") {
            setError(
              "Mobile number is already in use. Please use another mobile number.",
            );
          } else {
            console.log(error);
            setError(error.response.data.message);
          }
          setLoad(false);
        });
    } else {
      const map = new Map();
      error.forEach((item) => {
        map.set(item.label, item);
      });
      const filtered = Array.from(map.values());
      setErrorInputs(filtered);
      setLoad(false);
    }
  }

  let designationDepartment = {};

  return (
    <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row justify-content-center">
        <div className="col-md">
          <div className="p-2 bg-white rounded">
            <div className="my-2" id="candidateForm">
              {form?.elements?.map((element, key) => {
                // edit candidate of simple formdata(not bulkupload data)
                let cloneElement = JSON.parse(JSON.stringify(element));
                const newElement = {
                  ...prefilledDocData(
                    cloneElement,
                    formData,
                    candidateInformation,
                    ocrData,
                    ADDRESS,
                    ZIP,
                    designationDepartment,
                  ),
                  editable: true,
                };
                return (
                  <GetFormComponent
                    cInfo={candidateInformation}
                    onBlurHandler={onBlurHandler}
                    isInputFieldTouched={isInputFieldTouched}
                    element={{ ...newElement }}
                    key={key}
                    approve={approve}
                    errorInputs={errorInputs}
                    form={formData}
                    ocrDisabled={ocrDisabled}
                    setOcrDisabled={setOcrDisabled}
                    fillOcrData={fillOcrData}
                    getCandidateFormsList={getCandidateFormsList}
                    tokenType="candidate.token"
                    formType={"Document"}
                    aiSettings={aiSettings}
                    departments={departments}
                    formId={FORM_ID}
                  />
                );
              })}
            </div>
            <div className="px-3 mb-1">
              <If test={error !== ""}>
                <div className="alert alert-danger">{error}</div>
              </If>
              {(localStorage.getItem("user.role") === "admin" ||
                rights === "candidate") && (
                <button
                  className={`btn ${
                    approve || status ? "btn-secondary" : "btn-primary"
                  }`}
                  type="submit"
                  onClick={onClickFormSubmit}
                  disabled={approve || status}
                >
                  Submit
                </button>
              )}
            </div>
            {reason && filled === false && (
              <div>
                <div className="d-flex">
                  <div className="reject_icon">
                    <i class="fa fa-close"></i>
                  </div>
                  Reason : {reason}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidateDocView;
